import { Fragment } from 'react'
import {
  Collapse,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

const ExpensesTableBody = ({
  open,
  expensesByRubrique,
  sortEcritures,
  type,
}) => {
  const numberCellStyle = {
    fontSize: '16px',
    textAlign: 'right',
    width: { lg: '9%', xs: '12%' },
  }

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        margin={1}
        sx={{ marginBottom: '15px', marginTop: '-5px', marginRight: '30px' }}
      >
        <Table size="small">
          <TableBody>
            {expensesByRubrique.map((expense, index) => {
              const sortedEcritures = sortEcritures(expense.ecritures)
              return (
                <Fragment key={index}>
                  {sortedEcritures.map((ecriture, indexCell) => {
                    return (
                      <TableRow
                        key={`${ecriture.date}-${ecriture.idJeu}-${ecriture.montant}`}
                        sx={{
                          height: '25px',
                          '&:hover': { backgroundColor: '#e9e9e9' },
                        }}
                      >
                        <TableCell sx={{ width: '55px' }}>
                          {ecriture.document && (
                            <IconButton
                              color="primary"
                              href={ecriture.document.url}
                              target="_blank"
                              sx={{ padding: '0px' }}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: '15px',
                            width: '40px',
                            padding: { lg: '6px 16px', xs: '0' },
                          }}
                        >
                          {new Intl.DateTimeFormat('fr-FR').format(
                            new Date(ecriture.date)
                          )}
                        </TableCell>
                        <TableCell sx={{ fontSize: '15px' }}>
                          {ecriture.matchingFields &&
                          ecriture.matchingFields.includes('libelle') ? (
                            <div style={{ fontWeight: 'bold' }}>
                              {ecriture.libelle}
                            </div>
                          ) : (
                            <div>{ecriture.libelle}</div>
                          )}
                        </TableCell>
                        {/* Value divided by 100 because they are stored in cents */}
                        <TableCell sx={numberCellStyle}>
                          {/* The condition is checking if the line should be bold because of the searchBar */}
                          {ecriture.matchingFields &&
                          ecriture.matchingFields.includes('montant') ? (
                            <div style={{ fontWeight: 'bold' }}>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(
                                type === 'produit'
                                  ? (-1 * ecriture.montant) / 100
                                  : ecriture.montant / 100
                              )}
                            </div>
                          ) : (
                            <div>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(
                                type === 'produit'
                                  ? (-1 * ecriture.montant) / 100
                                  : ecriture.montant / 100
                              )}
                            </div>
                          )}
                        </TableCell>
                        <TableCell sx={numberCellStyle}>
                          {ecriture.matchingFields &&
                          ecriture.matchingFields.includes('tva') ? (
                            <div style={{ fontWeight: 'bold' }}>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(Math.abs(ecriture.tva / 100))}
                            </div>
                          ) : (
                            <div>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(Math.abs(ecriture.tva / 100))}
                            </div>
                          )}
                        </TableCell>
                        <TableCell sx={numberCellStyle}>
                          {ecriture.matchingFields &&
                          ecriture.matchingFields.includes('recuperable') ? (
                            <div style={{ fontWeight: 'bold' }}>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(Math.abs(ecriture.recuperable / 100))}
                            </div>
                          ) : (
                            <div>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(Math.abs(ecriture.recuperable / 100))}
                            </div>
                          )}
                        </TableCell>
                        <TableCell sx={numberCellStyle}>
                          {ecriture.matchingFields &&
                          ecriture.matchingFields.includes('deductible') ? (
                            <div style={{ fontWeight: 'bold' }}>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(Math.abs(ecriture.deductible / 100))}
                            </div>
                          ) : (
                            <div>
                              {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(Math.abs(ecriture.deductible / 100))}
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </Fragment>
              )
            })}
          </TableBody>
        </Table>
      </Box>
    </Collapse>
  )
}

export default ExpensesTableBody
